import React, {useEffect, useRef} from 'react'
import $ from "jquery";
import config from "../../config.js";

const CustomDataTable = ({onFileSelect,columns,url,table_id,columnDefs=[],order =  [[0, "desc"]] , FilterParams =[]}) => {
    const $ = require("jquery");
    let DataTable = require("datatables.net-bs4");
    let buttons = require( 'datatables.net-buttons' )();
    require("datatables.net-responsive-bs4");
    require("jquery-datatables-checkboxes");
    require( 'datatables.net-buttons/js/buttons.print.js' )();
    require( 'datatables.net-buttons/js/buttons.html5.js' )();
    require( 'datatables.net-buttons/js/buttons.colVis.js' )();
    const transfiles = { en: "../../DataTables/English.json", ar: '../../DataTables/Arabic.json' }

    useEffect(() => {

        // begin first table
        $.fn.dataTable.ext.errMode = 'none';
        $('#'+table_id).DataTable({
            responsive: true,
            searchDelay: 50,
            processing: true,
            serverSide: true,
            ajax: {
                "url": config.SystemUrl + url,
                "data": function (data) {

                    FilterParams.forEach(el => {
                        // if (el != "role_id" && !!Params) {
                            data[el] = function () {
                                return $(`select[name="data[${el}]"]`).val() || $(`input[name="data[${el}]"]`).val();
                            }
                        // }
                    })
                    console.log('data',data);
                },
                xhrFields: {
                    withCredentials: true
                }
            },
            columns: columns,
            "order": order,
            columnDefs: columnDefs,
            'select': {
                'style': 'multi'
            },
            dom: '<"top"<"left-col"B><"center-col"l><"right-col"f>>rtip',
            buttons: [
                'csv',
                'excel',
                { extend: 'print', exportOptions:
                        { columns: ':visible' }
                },
                { extend: 'copy', exportOptions:
                        { columns: [ 0, ':visible' ] }
                },
                { extend: 'excel', exportOptions:
                        { columns: ':visible' }
                },
                { extend: 'pdf', exportOptions:
                        { columns: [ 0, 1, 2, 3, 4 ] }
                },
                { extend: 'colvis',   postfixButtons: [ 'colvisRestore' ] },
            ],
            lengthMenu:[ [10, 25, 50, 100,1000, -1], [10, 25, 50, 100,1000, "All"] ],
            language: {
                url: transfiles[localStorage.getItem('lang') || 'en']
            }
        });

    }, []);
    return (
        <table
            id={table_id}
            className="table table-striped table-hover"
            width="100%"
            cellSpacing="0"
        />
       );
}
export default CustomDataTable;
